import React, { Component } from 'react'
import StaffList from './StaffList'
import AttendanceHeader from './AttendanceHeader'
import { PostCard } from '../../../../components/Main/Dashboard/WallTimeLine'

// import ToggleButton from 'react-toggle-button'

class Attendance extends Component {
  render() {
    const { list, fetchingActions, fetch, fetchingList } = this.props
    return (
      <div style={{ padding: '10px', width: '100%' }}>
        <PostCard bordered={false} title={<AttendanceHeader fetching={fetchingActions} {...this.props} />}>
          <StaffList fetch={fetch} fetching={fetchingList} list={list} />
        </PostCard>
      </div>
    )
  }
}

Attendance.propTypes = {}
Attendance.defaultProps = {}

export default Attendance
